@switch (variant) {
  @case ('text') {
    <ng-container *ngTemplateOutlet="textViewTemplate"></ng-container>
  }
  @default {
    <ng-container *ngTemplateOutlet="buttonViewTemplate"></ng-container>
  }
}

<ng-template #textViewTemplate>
  @if (beatmakerId !== userId) {
    <span class="follow-btn" (click)="handleClickFollowBtn()">
      {{ isFollowedByCurrentUser ? lg.producerPage.button.following : lg.producerPage.button.follow }}
    </span>
  }
</ng-template>

<ng-template #buttonViewTemplate>
  @if (beatmakerId !== userId) {
    <bmcore-button
      title="{{ getFollowBtnText() }}"
      styleName="{{ isFollowedByCurrentUser && 'grey' }}"
      icon="btv-icon-follow"
      class="follow"
      (mouseover)="isHovered = true"
      (mouseleave)="isHovered = false"
      (click)="handleClickFollowBtn()"
    ></bmcore-button>
  }
</ng-template>
